import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { History, Layers } from "lucide-react";

// Shared "pick up where you left off" rail — the current user's most recently worked, still-open
// estimates. Each card deep-links straight back to the exact tab / takeoff drawing they were on.
export function ResumeRail({ className = "" }) {
  const navigate = useNavigate();
  const [resume, setResume] = useState([]);
  useEffect(() => { api.get("/resume").then((r) => setResume(r.data || [])).catch(() => {}); }, []);

  const href = (r) =>
    r.drawing_id ? `/bids/${r.bid_id}?tab=takeoff&drawing=${r.drawing_id}`
      : r.tab ? `/bids/${r.bid_id}?tab=${r.tab}`
        : `/bids/${r.bid_id}`;

  if (resume.length === 0) return null;
  return (
    <section className={`mb-8 ${className}`} data-testid="resume-rail">
      <div className="flex items-center gap-2 mb-3">
        <History className="w-4 h-4 text-[#003E87]" />
        <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-600">Pick up where you left off</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {resume.map((r) => (
          <Card key={r.bid_id} data-testid={`resume-card-${r.bid_id}`} onClick={() => navigate(href(r))}
            className="p-4 cursor-pointer hover:border-[#003E87]/40 hover:shadow-sm transition group">
            <div className="text-sm font-medium text-black line-clamp-2 mb-2 group-hover:text-[#003E87]">{r.name}</div>
            <div className="flex items-center gap-1.5 text-xs text-slate-500 mb-3">
              <Layers className="w-3.5 h-3.5 text-slate-400 shrink-0" />
              <span className="truncate" data-testid={`resume-label-${r.bid_id}`}>{r.label}</span>
            </div>
            <div className="flex items-center justify-between text-[11px] text-slate-400">
              <span className="truncate">{r.client_name || "No client"}</span>
              <span className="font-mono">{r.progress || 0}%</span>
            </div>
            <div className="mt-1.5 h-1 rounded-full bg-slate-100 overflow-hidden">
              <div className="h-full bg-[#003E87]" style={{ width: `${r.progress || 0}%` }} />
            </div>
          </Card>
        ))}
      </div>
    </section>
  );
}
